import { encode } from "base-64";
import ChevronDownIcon from "../../atoms/images/ChevronDownIcon";
import Text from "../content/Text";

const doSsoRedirect = async (ssoTarget, accessToken, returnUrl) => {
  const baseUrl = ssoTarget.endsWith("/") ? ssoTarget : ssoTarget + "/";

  // Step 1: POST to Identity API sso-login — get verificationCode + sessionCode
  const baseHeaders = {
    Authorization:
      "Basic " +
      encode(
        process.env.REACT_APP_CMS_USERNAME +
          ":" +
          process.env.REACT_APP_CMS_PASSWORD
      ),
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers":
      "Origin, X-Requested-With, Content-Type, Accept",
  };

  const startRes = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/user/sso-login`,
    {
      method: "POST",
      headers: baseHeaders,
      body: JSON.stringify({ AccessToken: accessToken, TargetDomain: ssoTarget }),
    }
  );

  if (!startRes.ok) throw new Error(`sso-login HTTP ${startRes.status}`);

  const startData = await startRes.json();
  if (!startData.verificationCode || !startData.sessionCode)
    throw new Error("sso-login: missing verificationCode or sessionCode");

  // Step 2: Form POST to SSOLoginComplete — server sets cookies & redirects
  const form = document.createElement("form");
  form.method = "POST";
  form.action = `${baseUrl}home/SSOLoginComplete`;

  const addField = (name, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  addField("verificationCode", startData.verificationCode);
  addField("sessionCode", startData.sessionCode);
  if (returnUrl) addField("returnUrl", returnUrl);

  document.body.appendChild(form);
  form.submit();
};

const BrandTile = ({ logoSrc, href, text, vertical, ssoTarget, returnUrl, getAccessToken }) => {
  const handleSsoClick = async (e) => {
    e.preventDefault();
    const token = getAccessToken();
    if (!token) return;
    try {
      await doSsoRedirect(ssoTarget, token, returnUrl);
    } catch (err) {
      console.error("SSO redirect failed:", err);
      // Fallback: navigate to normal href
      if (href) window.location.href = href;
    }
  };

  const content = (
    <>
      <div
        className={`flex ${
          vertical ? "flex-col" : "flex-row"
        } justify-center items-center gap-1`}
      >
        <img src={logoSrc} alt={text} className="h-6 object-contain" />
        <Text variant="label" className="cursor-pointer">
          {text}
        </Text>
      </div>
      <div className="absolute right-4 top-1/2 -translate-y-1/2 -rotate-90">
        <ChevronDownIcon size={9} className="text-vestelColor" />
      </div>
    </>
  );

  if (ssoTarget && getAccessToken) {
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={handleSsoClick}
        onKeyDown={(e) => e.key === "Enter" && handleSsoClick(e)}
        className="relative w-full flex flex-col justify-center h-[75px] p-4 bg-[#F5F5F7] cursor-pointer"
      >
        {content}
      </div>
    );
  }

  return (
    <a
      href={href}
      role="div"
      className="relative w-full flex flex-col justify-center h-[75px] p-4 bg-[#F5F5F7] cursor-pointer"
    >
      {content}
    </a>
  );
};

export default BrandTile;
